// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {ArrowHead} from './arrow-head.js'
import {Point} from './point.js'

export class Line {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Line {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsLine(bb: flatbuffers.ByteBuffer, obj?: Line): Line {
    return (obj || new Line()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsLine(bb: flatbuffers.ByteBuffer, obj?: Line): Line {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new Line()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  start(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  controlPoint1(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  controlPoint2(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  end(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  arrowHead(): ArrowHead {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : ArrowHead.None
  }

  static startLine(builder: flatbuffers.Builder) {
    builder.startObject(5)
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, startOffset, 0)
  }

  static addControlPoint1(builder: flatbuffers.Builder, controlPoint1Offset: flatbuffers.Offset) {
    builder.addFieldStruct(1, controlPoint1Offset, 0)
  }

  static addControlPoint2(builder: flatbuffers.Builder, controlPoint2Offset: flatbuffers.Offset) {
    builder.addFieldStruct(2, controlPoint2Offset, 0)
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, endOffset, 0)
  }

  static addArrowHead(builder: flatbuffers.Builder, arrowHead: ArrowHead) {
    builder.addFieldInt8(4, arrowHead, ArrowHead.None)
  }

  static endLine(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // start
    builder.requiredField(offset, 10) // end
    return offset
  }
}
